import { createSystem, defaultConfig, defineConfig, defineSlotRecipe } from "@chakra-ui/react";

const customDrawerRecipe = defineSlotRecipe({
  slots: [
    "trigger",
    "backdrop",
    "positioner",
    "content",
    "title",
    "description",
    "closeTrigger",
    "header",
    "body",
    "footer",
  ],
  variants: {
    size: {
      "2xl": {
        content: { maxWidth: "68rem" },
      },
    },
  },
});

const config = defineConfig({
  theme: {
    breakpoints: {
      xmd: "880px", // extra-md, between md and lg
    },
    slotRecipes: {
      drawer: customDrawerRecipe,
    },
  },
});

export const system = createSystem(defaultConfig, config);

export default system;
